import angular from 'angular';

angular.module('cxRegistrations').directive('cxTypeaheadCarla', function() {
  return {
    restrict: 'E',
    replace: true,
    template: `<div class="dropdown dropdown-full-width" uib-dropdown>
                <div ng-class="{'input-group':!disabled && options.length}">
                  <input id="{{id}}-Input"
                        type="text"
                        ng-disabled="disabled"
                        ng-model="value"
                        ng-change="onChange()"
                        ng-blur="onBlur()"
                        uib-typeahead="item as item.name for item in options | filter:search($viewValue) | orderBy:['code','name'] | limitTo:15"
                        typeahead-is-open="test.isOpen"
                        typeahead-min-length="1"
                        typeahead-select-on-blur="true"
                        typeahead-select-on-exact="true"
                        class="form-control"
                        autocomplete="off"/>
                    <span class="input-group-btn"
                          ng-hide="disabled || !options.length">
                      <button id="{{id}}-Button"
                              class="btn btn-default dropdown-toggle btn-font-14"
                              ng-disabled="disabled || !options.length"
                              uib-dropdown-toggle>
                        <span class="caret"></span>
                      </button>
                    </span>
                </div>
                <ul class="dropdown-menu"
                    role="menu"
                    style="max-height:200px; overflow-y:auto;">
                  <li ng-repeat="item in options | orderBy:['code','name']"
                      ng-class="{'active':item.id===registration.resource.id}">
                    <a id="Resource-{{item.id}}"
                       href=""
                       ng-click=onSelect(item)
                       ng-bind="item.name">
                    </a>
                  </li>
                </ul>
              </div>`,
    require: 'ngModel',
    scope: {
      registration: '=ngModel',
      options: '=',
      disabled: '=ngDisabled',
      onChanged: '&',
      id: '@',
    },
    controller: [
      '$scope',
      'translateListFilter',
      function($scope, translateListFilter) {
        $scope.onSelect = function(item) {
          $scope.registration.resource = item;
          $scope.registration.resourceDescription = '';
          $scope.value = item.name;
          $scope.onChanged();
        };

        $scope.onChange = function() {
          $scope.registration.resourceDescription = $scope.value;
          if (!$scope.registration.resource || !$scope.registration.resource.isOther) {
            $scope.registration.resource = {
              isOther: true,
            };
            $scope.registration.price = null;
            $scope.registration.priceOptions = null;
          }
        };

        $scope.search = function(searchValue) {
          if (!searchValue) return null;
          return function(resource) {
            if (resource.code && resource.code.indexOf(searchValue) === 0) return true;
            if (
              resource.name &&
              resource.name.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
            )
              return true;
            if (
              resource.categoryName &&
              resource.categoryName.toLowerCase().indexOf(searchValue.toLowerCase()) >= 0
            )
              return true;
            return false;
          };
        };

        $scope.onBlur = function() {
          if (
            $scope.registration.resource != $scope.value &&
            $scope.options.indexOf($scope.value) >= 0
          ) {
            $scope.registration.resource = $scope.value;
            $scope.registration.resourceDescription = '';
            $scope.value = $scope.value.name;
            $scope.onChanged();
          }
        };

        $scope.$watch('registration', function(newValue, oldValue) {
          $scope.value =
            $scope.registration.resource && !$scope.registration.resource.isOther
              ? translateListFilter(
                  $scope.registration.resource.id,
                  'resource',
                  $scope.registration.resource.name,
                )
              : $scope.registration.resourceDescription;
        });

        $scope.$watch('registration.resource', function(newValue, oldValue) {
          if (newValue == null) {
            $scope.value = '';
          } else if (newValue && newValue.id && newValue.name !== $scope.value) {
            $scope.value = translateListFilter(newValue.id, 'resource', newValue.name);
          }
        });
      },
    ],
  };
});
